export const isCardNumberValid = (cardNumber: string) => {
  const cleanCardNumber = cardNumber.replace(/\s+|-/g, '');
  let sum = 0;
  let alt = false;
  let i = cleanCardNumber.length - 1;
  let num;

  while (i >= 0) {
    num = parseInt(cleanCardNumber.charAt(i), 10);

    if (alt) {
      num *= 2;
      if (num > 9) {
        num = (num % 10) + 1;
      }
    }
    alt = !alt;
    sum += num;
    i--;
  }

  return sum % 10 === 0;
};
